export const digitCounts = {
  'RAR': 1,
  'K:D': 2,
  'KAST+-': 1,
  'KPR': 2,
  'APR': 2,
  'ADR': 0
}
